import httpClientFactory from "./http-client.factory";
import {AxiosInstance} from "axios";

export const httpClient: AxiosInstance = httpClientFactory();
